import { combineReducers } from '@ngrx/store';
import { ContextKey, contextReducer } from './context/context.reducer';
import { CreativeKey, creativeReducer } from './creative/creative.reducer';

export const StoreKey = 'DashboardFeatureCreative';

export const storeReducer = combineReducers({
  [ContextKey]: contextReducer,
  [CreativeKey]: creativeReducer,
});
